import AppConsts from './appconst';

const { abp } = window;

export function L(key, sourceName) {
  const localizationSourceName =
    AppConsts.localization.defaultLocalizationSourceName;
  return abp.localization.localize(key, sourceName ?? localizationSourceName);
}

export function isGranted(permissionName) {
  return abp.auth.isGranted(permissionName);
}

export function isAnyGranted(permissionName) {
  return abp.auth.isAnyGranted(permissionName);
}

export function areAllGranted(permissionName) {
  return abp.auth.areAllGranted(permissionName);
}
